import axiosInstance from '@/app/api/axiosInstance';
import { Category, CategoryCreate, CategoryUpdate } from '@/app/types/category';
import { PaginatedResponse, ListQueryParams } from '@/app/types/api';
import { createOrganizationFilter } from '@/app/utils/filterUtils';

export const listCategories = async (params: ListQueryParams, organizationId: number): Promise<PaginatedResponse<Category>> => {
  try {
    const requestParams = {
      ...params,
      ...(params.filters && typeof params.filters === 'string'
        ? { filters: params.filters }
        : organizationId 
            ? { filters: createOrganizationFilter(organizationId) }
            : {})
    };

    const response = await axiosInstance.get<PaginatedResponse<Category>>('/categories/', { 
      params: requestParams 
    });
    
    return response.data;
  } catch (error) {
    console.error('Failed to list categories:', error);
    throw error;
  }
};

export const getCategory = async (categoryId: number): Promise<Category> => {
  try {
    const response = await axiosInstance.get<Category>(`/categories/${categoryId}`);
    return response.data;
  } catch (error) {
    console.error(`Failed to get category with ID ${categoryId}:`, error);
    throw error;
  }
};

export const createCategory = async (data: CategoryCreate, organizationId: number): Promise<Category> => {
  try {
    const categoryData = {
      ...data,
      organization_id: organizationId
    };
    
    const response = await axiosInstance.post<Category>('/categories/', categoryData);
    return response.data;
  } catch (error) {
    console.error('Failed to create category:', error);
    throw error;
  }
};

export const updateCategory = async (categoryId: number, data: CategoryUpdate): Promise<Category> => {
  try {
    const response = await axiosInstance.patch<Category>(`/categories/${categoryId}`, data);
    return response.data;
  } catch (error) {
    console.error(`Failed to update category with ID ${categoryId}:`, error);
    throw error;
  }
};

export const deleteCategory = async (categoryId: number): Promise<void> => {
  try {
    await axiosInstance.delete(`/categories/${categoryId}`);
  } catch (error) {
    console.error(`Failed to delete category with ID ${categoryId}:`, error);
    throw error;
  }
}; 